import { render, staticRenderFns } from "./EditarContacto.vue?vue&type=template&id=5d824cb2&scoped=true&"
import script from "./EditarContacto.vue?vue&type=script&lang=js&"
export * from "./EditarContacto.vue?vue&type=script&lang=js&"
import style0 from "./EditarContacto.vue?vue&type=style&index=0&id=5d824cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d824cb2",
  null
  
)

export default component.exports